import { useEffect, useState } from 'react';
import { notification } from 'antd';
import { Button } from 'components/common';
import { UpgradeLicense } from 'utils/constants';

import { usePost, useDel, useAuth } from 'hooks';
import { tradeshowCalendar } from 'services/api';

const RegisterInterestButton = ({ id, isRegistered, rowData }) => {
  const { user } = useAuth();
  const [
    { res: registeredSuccess, loading: registering },
    postInterest,
  ] = usePost({
    url: tradeshowCalendar,
    body: { id },
  });
  const [
    { res: deregisteredSuccess, loading: deregistering },
    delInterest,
  ] = useDel({
    url: tradeshowCalendar,
    query: { id },
  });

  const [registered, setRegistered] = useState(isRegistered);

  useEffect(() => {
    if (registeredSuccess) {
      notification.open({
        message: 'Interest Registered',
        description: (
          <div>
            Thank you for registering your interest in this event.
            <br />
            <br />
            You will receive an automated alert once tradeshow data becomes
            available.
          </div>
        ),
        placement: 'bottomLeft',
      });
      setRegistered(true);
      rowData.isUserRegistered = true;
    }
  }, [registeredSuccess, rowData]);

  useEffect(() => {
    if (deregisteredSuccess) {
      notification.open({
        message: 'Interest Removed',
        description: (
          <div>Your interest in this Tradeshow has been cancelled.</div>
        ),
        placement: 'bottomLeft',
      });
      setRegistered(false);
      rowData.isUserRegistered = false;
    }
  }, [deregisteredSuccess, rowData]);

  const handleRegister = () => {
    postInterest();
  };

  const handleDeregister = () => {
    delInterest();
  };

  return (
    <Button
      disabled={registering || deregistering || user.isPartnerAccount}
      tooltip={user.isPartnerAccount ? <UpgradeLicense /> : ''}
      onClick={registered ? handleDeregister : handleRegister}
      size='small'
    >
      {registered ? 'Un-Register Interest' : 'Register Interest'}
    </Button>
  );
};

export default RegisterInterestButton;
